import React from 'react';
import Container from 'react-bootstrap/Container';


function About() {
    return (

        <Container className="fullHeight">
            <h4>Title</h4>
            <p>text Lorem, ipsum dolor sit amet consectetur adipisicing elit. Earum maiores magnam ea quae a voluptatem iusto, saepe atque, enim repellendus, nihil inventore harum error? Est consectetur ea, reiciendis ex, quo nisi aperiam dicta rerum maxime, ratione esse placeat amet pariatur!</p>
            <div>
                <div className="form">sugestions for booksmarks</div>
            </div>
        </Container>
    )
}

export default About;